















import { SortingOption } from '../marketplace-model'
export default {
  props: {
    sortBy: { type: String, default: SortingOption.Relevance }
  },
  data() {
    return {
      selectedOptionKey: this.sortBy
    }
  },
  computed: {
    value: {
      get() {
        return this.options.find(item => item.key === this.selectedOptionKey)
      },
      set(value) {
        if (value) {
          this.selectedOptionKey = value.key
        }
      }
    },
    options() {
      return [
        {
          label: this.$t(`marketPlace.orderingOptions.newest`),
          key: SortingOption.Newest
        },
        {
          label: this.$t(`marketPlace.orderingOptions.oldest`),
          key: SortingOption.Oldest
        },
        {
          label: this.$t(`marketPlace.orderingOptions.relevance`),
          key: SortingOption.Relevance
        }
      ]
    }
  },
  watch: {
    sortBy() {
      this.selectedOptionKey = this.sortBy
    }
  },
  methods: {
    updateOrder() {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, page: 1, sort: this.value.key }
      })
    }
  }
}
